import { ref } from 'vue'

interface ConfirmOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  danger?: boolean
}

const visible = ref(false)
const options = ref<ConfirmOptions>({ title: '', message: '' })
let resolvePromise: ((value: boolean) => void) | null = null

function confirm(opts: ConfirmOptions): Promise<boolean> {
  options.value = opts
  visible.value = true
  return new Promise((resolve) => {
    resolvePromise = resolve
  })
}

function handleConfirm() {
  visible.value = false
  resolvePromise?.(true)
  resolvePromise = null
}

function handleCancel() {
  visible.value = false
  resolvePromise?.(false)
  resolvePromise = null
}

export function useConfirm() {
  return {
    visible,
    options,
    confirm,
    handleConfirm,
    handleCancel,
  }
}
